@if (useLocation) {
    <div>
        <p class="filter-range-title">
            <span>{{ configuration.label }}</span>
            @if (maxValue === configuration.maxRange || maxValue === configuration.minRange) {
                <span> Everywhere </span>
            } @else {
                <span>
                    {{ maxValue | number }}
                    @if (maxValue === configuration.maxRange) {
                        <i>+</i>
                    }
                </span>
                <span> {{ configuration.rangeType }} </span>
            }
        </p>
        <ngx-slider
            [options]="options"
            [(value)]="maxValue"
            (userChange)="onChange($event)"
            (userChangeEnd)="onChange($event)"
        >
        </ngx-slider>
    </div>
} @else {
    <div class="no-location-message">
        <fa-icon [icon]="['fas', 'exclamation-triangle']"></fa-icon>
        {{ configuration.noLocationMessage }}
    </div>
}
